import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
// @ts-igore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import MalSearchOption from '@/components/MalSearchOption.vue';
let MalfCalender = class MalfCalender extends Vue {
    constructor() {
        super();
        this.menuDvice = {
            visible: false,
            text: '',
        };
        this.menuSearch = false;
        this.snackbar = new CBcSnackbar();
        this.pageLoading = false;
        this.formValid = false;
        this.listDevice = [];
        this.list = [];
        this.listStatus = [];
        this.listCategories = [];
        this.listModules = [];
        this.listDates = [];
        this.exportDataMenu = [];
        this.value = '';
        this.colors = ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'];
        this.listHospital = [];
        const that = this;
        this.formData = {
            deviceId: 0,
            description: '',
            device: ''
        };
        this.currentItem = {
            deviceId: 0,
            description: ''
        };
        this.menuDatePicker = {
            visible: false,
            date: '',
            events: [],
        };
        this.formDataMenu = {
            date: false,
            solveDate: false,
            expectedSolveDate: false,
        };
        this.editFormPanels = [];
        this.tableOptions = {
            visible: false,
            total: 0,
            pageSize: 10,
            page: 1,
            expanded: []
        };
        this.searchOptions = {
            hospital: '',
            text: '',
            date: Vue.filter('dateFormat')(new Date(), 'yyyy-MM-dd'),
            deviceType: null,
            deviceMode: null,
            device: null,
            status: '',
            deviceInput: '',
        };
        this.dialogAlone = {
            description: '',
            reason: ''
        };
        this.exportDataMenu = ['台式西林设备', '台式安瓿设备', '综合配药设备'];
    }
    set searchOptionsDeviceText(val) {
        const that = this;
        if (that.searchOptions.hospital || that.searchOptions.deviceType || that.searchOptions.deviceMode || that.searchOptions.device) {
            if (that.searchOptions.device)
                that.searchOptions.device = null;
            if (that.searchOptions.deviceMode)
                that.searchOptions.deviceMode = null;
            if (that.searchOptions.deviceType)
                that.searchOptions.deviceType = null;
            if (that.searchOptions.hospital)
                that.searchOptions.hospital = null;
            that.getList();
        }
    }
    get searchOptionsDeviceText() {
        const that = this;
        if (that.searchOptions.hospital || that.searchOptions.deviceType || that.searchOptions.deviceMode || that.searchOptions.device) {
            if (that.searchOptions.device)
                return that.searchOptions.device.deviceName;
            if (that.searchOptions.deviceMode)
                return that.searchOptions.deviceMode;
            if (that.searchOptions.deviceType)
                return that.searchOptions.deviceType;
            if (that.searchOptions.hospital)
                return that.searchOptions.hospital.name;
        }
        return '';
    }
    async mounted() {
        const that = this;
        const rQuery = that.$router.currentRoute.query;
        if (rQuery && rQuery.device) {
            that.searchOptions.device = rQuery.device;
        }
        that.fetchMalfunctionCatalog({ dateType: 'month' }).then((v) => {
            that.catalogHandle(v);
        });
        that.getHospitalList();
        that.getList();
    }
    catalogHandle(category) {
        const that = this;
        if (category) {
            that.listCategories = [...that.malfunctionCategories, ...that.listCategories, '电气', '机械', '软件', '其它']
                .concat(String(category.categories).split(',').filter((v) => !!v)).filter((v, i, a) => (v !== undefined && v !== null) && String(v).length && a.indexOf(v, 0) === i).sort((a, b) => a.localeCompare(b));
            that.listModules = [...that.malfunctionModules, ...that.listModules, '电气', '软件', '卸料', '转盘', '输液袋', '注射旋转', '抽吸注射', '其它']
                .concat(String(category.modules).split(',').filter((v) => !!v)).filter((v, i, a) => (v !== undefined && v !== null) && String(v).length && a.indexOf(v, 0) === i).sort((a, b) => a.localeCompare(b));
            that.listDates = [...that.malfunctionDates, ...that.listDates].concat(String(category.dates).split(',')).filter((v, i, a) => (v !== undefined && v !== null) && String(v).length && a.indexOf(v, 0) === i);
        }
    }
    deviceTextFilter(item, queryText, itemText) {
        const that = this;
        const reg = new RegExp(queryText);
        const match = (reg.test(item.deviceName) || reg.test(item.deviceMode) || reg.test(item.deviceNo) || reg.test(item.deviceId) || reg.test(item.deviceType));
        return match ? itemText : null;
    }
    searchOptionsDeviceClick() {
        const that = this;
        that.getList();
        that.menuDvice.visible = false;
    }
    set getCalenderModel(val) {
        const that = this;
        that.searchOptions.date = val;
    }
    get getCalenderModel() {
        const that = this;
        return Vue.filter('dateFormat')(new Date(that.searchOptions.date), 'yyyy-MM-dd');
    }
    getEventColor(event) {
        return event.color || '';
    }
    getEvents(obj) {
        const that = this;
        return false;
        // return that.calendarChange(obj);
    }
    getHospitalList() {
        const that = this;
        try {
            const ret = that.axios.get('/api/hospital', { params: { simple: true } }).then((res) => {
                const devices = [];
                that.listHospital = (res && res.data && res.data.result || []).map((v) => {
                    devices.push(...v.devices);
                    return v;
                });
                that.listDevice = devices;
                return res;
            });
            return ret;
        }
        catch (e) {
            // that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    calendarNext(data) {
        const that = this;
        that.searchOptions.date = data.start.date;
        return that.getList();
    }
    calendarPrev(data) {
        const that = this;
        that.searchOptions.date = data.start.date;
        return that.getList();
    }
    calendarChange(data) {
        const that = this;
        that.searchOptions.date = data.start.date;
        return that.getList();
    }
    getList() {
        const that = this;
        that.tableLoading = true;
        that.pageLoading = true;
        try {
            const hosp = that.searchOptions.hospital;
            const det = that.searchOptions.deviceType;
            const dem = that.searchOptions.deviceMode;
            const de = that.searchOptions.device;
            const st = that.searchOptions.status;
            const da = that.searchOptions.date;
            const tx = that.searchOptions.text;
            const ca = that.searchOptions.category;
            const mu = that.searchOptions.module;
            const params = Object.assign({
                limit: that.tableOptions.pageSize,
                page: that.tableOptions.page,
            }, hosp ? { hospitalId: hosp.id } : {}, dem ? { deviceMode: dem } : {}, det ? { deviceType: det } : {}, de ? { deviceId: de.deviceId } : {}, st ? { status: st } : {}, { month: new Date(that.searchOptions.date || null) }, tx ? { text: tx } : {}, ca ? { category: ca } : {}, mu ? { module: mu } : {});
            const ret = that.axios.get('/api/malfunctions/date', {
                params: params
            }).then((res) => {
                that.pageLoading = false;
                that.list = (res && res.data && res.data.result || []).map((v) => {
                    // eslint-disable-next-line no-shadow
                    const st = Vue.filter('dateFormat')(new Date(v.date), 'yyyy-MM-dd');
                    const val = {
                        name: `${v.deviceInfo && v.deviceInfo.name}${v.category ? `-${v.category}` : ''}${v.module ? `-${v.module}` : ''}-${v.times || 0}次`,
                        category: v.category,
                        start: st,
                        end: st,
                        color: v.times > 1 ? 'red' : 'orange',
                        timed: false,
                    };
                    return val;
                });
                that.tableOptions.total = res && res.data && res.data.sum || that.list.length;
                const category = res && res.data && res.data.category;
                return res;
            }).catch((e) => {
                throw e;
            });
            that.tableLoading = false;
            return ret;
        }
        catch (e) {
            that.pageLoading = false;
            that.tableLoading = false;
            that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    getDevices() {
        const that = this;
        return that.axios.get('/api/device', { params: {} }).then((res) => {
            that.listDevice = res && res.data && res.data.result || [];
            return res;
        });
    }
    getMalfunctionStatus() {
        const that = this;
        return that.axios.get('/api/malfunctions/status', { params: {} }).then((res) => {
            that.listStatus = res && res.data && res.data.result || [];
            return res;
        });
    }
    statusNameToObject(iname) {
        const it = this.listStatus.find((v) => v.name === iname);
        return it || { name: iname, color: 'lightgray', code: '', description: '' };
    }
    getStatusColor(iname) {
        const it = this.statusNameToObject(iname);
        return it && it.color || 'lightgray';
    }
    getDeviceItem(id, key) {
        const that = this;
        const it = that.listDevice.find((v) => v.id === id);
        return it && it[key] || '';
    }
    onQuerySearchOptionsDateChange(newVal) {
        const that = this;
        that.getList();
    }
};
__decorate([
    Getter
], MalfCalender.prototype, "userInfo", void 0);
__decorate([
    Getter
], MalfCalender.prototype, "deviceSerialList", void 0);
__decorate([
    Getter
], MalfCalender.prototype, "deviceTypeList", void 0);
__decorate([
    Getter
], MalfCalender.prototype, "malfunctionDates", void 0);
__decorate([
    Getter
], MalfCalender.prototype, "malfunctionCategories", void 0);
__decorate([
    Getter
], MalfCalender.prototype, "malfunctionModules", void 0);
__decorate([
    Action
], MalfCalender.prototype, "fetchMalfunctionCatalog", void 0);
__decorate([
    Watch('searchOptions.date')
], MalfCalender.prototype, "onQuerySearchOptionsDateChange", null);
MalfCalender = __decorate([
    Component({
        name: 'MalfunctionCalender',
        components: {
            BcSnackbar,
            MalSearchOption,
        }
    })
], MalfCalender);
export default MalfCalender;
;
